import { render, staticRenderFns } from "./fishingLayout.vue?vue&type=template&id=6e95705e&"
import script from "./fishingLayout.vue?vue&type=script&lang=js&"
export * from "./fishingLayout.vue?vue&type=script&lang=js&"
import style0 from "./fishingLayout.vue?vue&type=style&index=0&id=6e95705e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports